import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { B100, B200, B300, B400, B50, B75, DN10, DN200, DN30, DN80, DN90, N10, N100, N20, N30, N40, N70, R300 } from '@atlaskit/theme/colors';
var radioThemeColors = {
  light: {
    background: "var(--ds-background-input, ".concat(N10, ")"),
    backgroundHover: "var(--ds-background-input-hovered, ".concat(N30, ")"),
    backgroundActive: "var(--ds-background-input-pressed, ".concat(N30, ")"),
    backgroundChecked: "var(--ds-background-selected-bold, ".concat(B400, ")"),
    backgroundCheckedHover: "var(--ds-background-selected-bold-hovered, ".concat(B300, ")"),
    backgroundCheckedActive: "var(--ds-background-selected-bold-pressed, ".concat(B50, ")"),
    backgroundDisabled: "var(--ds-background-disabled, ".concat(N20, ")"),
    dotChecked: "var(--ds-icon-inverse, ".concat(N10, ")"),
    dotDisabled: "var(--ds-icon-disabled, ".concat(N70, ")"),
    dotActive: "var(--ds-icon-inverse, ".concat(B400, ")"),
    border: getBooleanFF('platform.design-system-team.update-border-radio-checkbox_7askv') ? "var(--ds-border-bold, ".concat(N100, ")") : "var(--ds-border-input, ".concat(N40, ")"),
    borderHover: getBooleanFF('platform.design-system-team.update-border-radio-checkbox_7askv') ? "var(--ds-border-bold, ".concat(N100, ")") : "var(--ds-border-input, ".concat(N40, ")"),
    borderDisabled: "var(--ds-border-disabled, ".concat(N20, ")"),
    borderFocus: "var(--ds-border-focused, ".concat(B100, ")")
  },
  dark: {
    background: "var(--ds-background-input, ".concat(DN10, ")"),
    backgroundHover: "var(--ds-background-input-hovered, ".concat(DN30, ")"),
    backgroundActive: "var(--ds-background-input-pressed, ".concat(B200, ")"),
    backgroundChecked: "var(--ds-background-selected-bold, ".concat(B400, ")"),
    backgroundCheckedHover: "var(--ds-background-selected-bold-hovered, ".concat(B75, ")"),
    backgroundCheckedActive: "var(--ds-background-selected-bold-pressed, ".concat(B200, ")"),
    backgroundDisabled: "var(--ds-background-disabled, ".concat(DN10, ")"),
    dotChecked: "var(--ds-icon-inverse, ".concat(DN10, ")"),
    dotDisabled: "var(--ds-icon-disabled, ".concat(DN90, ")"),
    dotActive: "var(--ds-icon-inverse, ".concat(DN10, ")"),
    border: getBooleanFF('platform.design-system-team.update-border-radio-checkbox_7askv') ? "var(--ds-border-bold, ".concat(DN200, ")") : "var(--ds-border-input, ".concat(DN80, ")"),
    borderHover: "var(--ds-border-input, ".concat(DN200, ")"),
    borderDisabled: "var(--ds-border-disabled, ".concat(DN10, ")"),
    borderFocus: "var(--ds-border-focused, ".concat(B75, ")")
  }
};
export default function getRadioCustomProperties(mode) {
  var radioColors = radioThemeColors[mode];
  return {
    '--local-background': radioColors.background,
    '--local-background-active': radioColors.backgroundActive,
    '--local-background-checked': radioColors.backgroundChecked,
    '--local-background-checked-active': radioColors.backgroundCheckedActive,
    '--local-background-checked-hover': radioColors.backgroundCheckedHover,
    '--local-background-disabled': radioColors.backgroundDisabled,
    '--local-background-hover': radioColors.backgroundHover,
    '--local-border': radioColors.border,
    '--local-border-disabled': radioColors.borderDisabled,
    '--local-border-hover': radioColors.borderHover,
    '--local-border-focus': radioColors.borderFocus,
    '--local-dot-active': radioColors.dotActive,
    '--local-dot-checked': radioColors.dotChecked,
    '--local-dot-disabled': radioColors.dotDisabled,
    '--local-invalid': "var(--ds-icon-danger, ".concat(R300, ")")
  };
}